import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query'
import { Mutex } from 'async-mutex'
import { getAccessToken, getUserId } from 'utils/common'

const mutex = new Mutex()

export const createBaseQueryWithReauth = (baseUrl: string) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    timeout: 2 * 60 * 1000, // 2 minutes
    prepareHeaders: (headers) => {
      const accessToken = getAccessToken()
      const userId = getUserId()

      if (!!accessToken) headers.set('Authorization', `Bearer ${accessToken}`)
      if (!headers.has('userId') && !!userId) headers.set('userId', userId)
      return headers
    },
  })

  const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
  > = async (args, api, extraOptions) => {
    await mutex.waitForUnlock()

    let result = await rawBaseQuery(args, api, extraOptions)

    if (
      result.error &&
      (result.error.status === 401 ||
        result.error.status === 403 ||
        result.error.status === 'FETCH_ERROR')
    ) {
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()
        try {
          const refreshResult = await rawBaseQuery(
            {
              url: 'oapi/v1/auth/refresh',
              method: 'POST',
              body: { refreshToken: sessionStorage.getItem('refreshToken') },
            },
            api,
            extraOptions
          )

          if (refreshResult.data) {
            const {
              accessToken: newAccessToken,
              refreshToken: newRefreshToken,
            } = refreshResult.data as any
            sessionStorage.setItem('accessToken', newAccessToken)
            sessionStorage.setItem('refreshToken', newRefreshToken)
            result = await rawBaseQuery(args, api, extraOptions)
          } else {
            console.error('Refresh failed. Logging out...')
            // optionally dispatch logout
          }
        } finally {
          release()
        }
      } else {
        await mutex.waitForUnlock()
        result = await rawBaseQuery(args, api, extraOptions)
      }
    }

    return result
  }

  return baseQueryWithReauth
}
